// extracted by mini-css-extract-plugin
export default {"container":"PriceList_container__-KbdW","wrapper":"PriceList_wrapper__dDzN-","footerStyle":"PriceList_footerStyle__-AGL7"};